import css from 'styled-jsx/css';

export default css`.login-form-validator-message {
    display: flex;
    align-items: center;
    padding-left: 15px;
    :global(svg) {
        width: 12px;
        height: 12px;
    }
    span {
        font-size: 12px;
        padding-left: 4px;
        flex: 1;
    }
}`